import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { serverHost } from "../config";

const ProtectedRoute = ({component: Component, ...rest}) =>
{
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    if(!isAuthenticated)
    {
        localStorage.clear();
        window.location.href = `${serverHost}/login`;
        return (<></>);
    }

    return(
        <Route {...rest} render={props =>
            {
                if(true)
                {
                    return <Component {...props} />;
                }
            }}
        />
    );
};

export default ProtectedRoute;